import React from 'react';

const getColor = (index: number) => {
  const colors = ['#3B82F6', '#8B5CF6', '#F59E0B', '#EC4899', '#10B981'];
  return colors[index] || '#3B82F6';
};

interface ModalityItem {
  label: string;
  total: number;
}

interface Props {
  data: ModalityItem[];
}

const TipoContratacaoOverview = ({ data }: Props) => {
  const max = Math.max(...data.map((r) => r.total), 1);

  return (
    <div>
      <h5 className="mb-3 d-flex align-items-center">Por Tipo de Contratação</h5>
      {data.map((item, index) => {
        const percentage = (item.total / max) * 100;

        return (
          <div key={item.label} className="mb-3">
            <div className="d-flex justify-content-between mb-1">
              <span>{item.label}</span>
              <span>{item.total}</span>
            </div>

            <div className="progress" style={{ height: 8 }}>
              <div
                className="progress-bar"
                style={{
                  width: `${percentage}%`,
                  backgroundColor: getColor(index),
                }}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TipoContratacaoOverview;
